import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { IWCCStorageManager } from 'managers/iStorage';
import { EffectsContainer } from 'mixins/withEffects';
import { ServicesContext } from 'services/context';
import TextThreadEditorVM, { TextThreadEditorVMConfig } from '../textThread';

@injectable()
export default class CommentEditorVM extends TextThreadEditorVM {
    constructor(
        @inject(wccModules.componentConfig) model: TextThreadEditorVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(model, info, storage, ctx, effects);
    }

    protected override checkIfShouldAutoSave() {
        return super.checkIfShouldAutoSave() ||
            this.isReady() &&
            this.videoMode() &&
            !this.isEditMode() &&
            !this.isReplyEditor() &&
            !this.isCaptionEditorNeeded() &&
            this.videos().length > 0;
    }
}